'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef } from 'react';
import { useEventListener } from 'usehooks-ts';
type UseExitIntentOptions = {
  enabled: boolean;
  onTrigger?: () => void;
};
type UseExitIntentReturn = {
  reset: () => void;
};
export function useExitIntent(t0) {
  const $ = _c(10);
  const {
    enabled,
    onTrigger
  } = t0;
  const hasTriggeredRef = useRef(false);
  const documentRef = useRef(typeof document !== "undefined" ? document : null);
  let t1;
  if ($[0] !== onTrigger) {
    t1 = () => {
      if (hasTriggeredRef.current) {
        return;
      }
      hasTriggeredRef.current = true;
      onTrigger?.();
    };
    $[0] = onTrigger;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const fire = t1;
  let t2;
  if ($[2] !== enabled || $[3] !== fire) {
    t2 = e => {
      if (!enabled) {
        return;
      }
      if (e.clientY <= 0) {
        fire();
      }
    };
    $[2] = enabled;
    $[3] = fire;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEventListener("mouseleave", t2, documentRef);
  let t3;
  if ($[5] !== enabled || $[6] !== fire) {
    t3 = () => {
      if (!enabled) {
        return;
      }
      if (document.visibilityState === "hidden") {
        fire();
      }
    };
    $[5] = enabled;
    $[6] = fire;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEventListener("visibilitychange", t3, documentRef);
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      hasTriggeredRef.current = false;
    };
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const reset = t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      reset
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}